import { endOfDay, startOfDay } from 'date-fns';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';

import {
  getOutboundOrderTrackingData,
  setDashboardOutboundOrdersDates,
  setSelectedUserBranches,
} from '../../app/store/actions/outboundOrders';

import { getBranchesOptions } from '../../app/store/actions/branches';

import {
  connectDashboardSocket,
  joinBranchRoom,
  onStatusChanged,
  offStatusChanged,
  onSocketConnect,
  onSocketDisconnect,
  disconnectDashboardSocket,
} from '../../app/services/dashboardSocket';

import DateRangePicker from '../../components/date/DateRangePicker.jsx';
import FilterSelectionList from '../../components/form/filterSelectionList';
import DigitalClock from '../../components/digitalClock/digitalClock';
import TrackingOrderCards from '../../components/dynamicCards/trackingOrderCards';
import addNotification from '../../components/notification/index';
import ROUTES from '../../config/routes';
import WikiHelp from '../../components/tooltip/wikiHelp';

class OutboundOrderTracking extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      socketConnected: false,
    };

    this.breadcrumb = [
      {
        value: I18n.t('BEE42' /* Dashboard */),
        iconClassName: 'fa fa-chart-line m-t-10 m-r-5',
      },
      { value: I18n.t('BEE41' /* Expedição */) },
      {
        value: I18n.t('BEE4353' /* Acompanhamento de Documentos de Saída */),
        active: true,
      },
    ];
  }

  async componentDidMount() {
    if (!this.props.location.state || !Object.keys(this.props.location.state).length) {
      const startDate = moment();
      const endDate = moment();
      const dates = { startDate, endDate };

      await this.props.setDashboardOutboundOrdersDates(dates);

      const listBranches = await this.props.getBranchesOptions();

      this.setState({
        listBranches,
      });
    }

    this.setupSocket();
    await this.getTracking();

    this.props.history.push({
      state: {},
    });
  }

  componentWillUnmount() {
    offStatusChanged(this.handleRealtimeStatusChange);
    disconnectDashboardSocket();
  }

  setupSocket = () => {
    this.dashboardSocket = connectDashboardSocket();
    if (!this.dashboardSocket) return;

    onSocketConnect(this.handleSocketConnect);
    onSocketDisconnect(this.handleSocketDisconnect);
    onStatusChanged(this.handleRealtimeStatusChange);

    if (this.dashboardSocket.connected) {
      this.handleSocketConnect();
    }
  };

  handleSocketConnect = () => {
    this.setState({ socketConnected: true });

    const branchCode = this.getSelectedBranchCode();
    if (branchCode) joinBranchRoom(branchCode);
  };

  handleSocketDisconnect = () => {
    this.setState({ socketConnected: false });
  };

  getSelectedBranchCode = () => {
    const selected = this.props.selectedBranches;
    if (!selected || !selected.length) return null;
    return String(selected[0].value).trim();
  };

  playBeep = () => {
    try {
      const context = new AudioContext();
      const oscillator = context.createOscillator();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(1000, context.currentTime);
      oscillator.connect(context.destination);
      oscillator.start();
      oscillator.stop(context.currentTime + 0.3);
    } catch (e) {
      // AudioContext não suportado
    }
  };

  formatTextForAudio = (text) => {
    if (!text) return '';
    return text
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  SafeTextLimiter = (text, maxChars = 50) => {
    if (!text) return null;

    // Limita o texto aos primeiros maxChars caracteres
    const limitedText = text.length > maxChars
      ? (() => {
        const spaceIndex = text.indexOf(' ', maxChars);
        const cutIndex = spaceIndex === -1 ? maxChars : spaceIndex;
        return `${text.substring(0, cutIndex)}...`;
      })() : text;

    return limitedText;
  };

  speakText = (text) => {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'pt-BR';
      window.speechSynthesis.speak(utterance);
    }
  };

  playSoundAlertAudio = (event) => {
    const {
      trackingDashboardSpeakOrderNumber,
      trackingDashboardSpeakCustomerName,
      trackingDashboardSoundOnBilling,
      trackingDashboardActivateSound,
    } = this.state;

    const orderNumber = String(event.orderNumber || '');
    const customerName = event.customer && event.customer.name
      ? event.customer.name
      : '';
    const explodedId = orderNumber.split('').join(' ');

    let audioText = '';

    if (trackingDashboardActivateSound && event.newStatus === 14) {
      if (trackingDashboardSpeakOrderNumber && !trackingDashboardSpeakCustomerName) {
        audioText = I18n.t('BEE4361', {
          0: this.formatTextForAudio(explodedId),
        });
      } else if (trackingDashboardSpeakCustomerName && !trackingDashboardSpeakOrderNumber) {
        audioText = I18n.t('BEE4428', {
          0: this.formatTextForAudio(this.SafeTextLimiter(customerName)),
        });
      } else if (trackingDashboardSpeakOrderNumber && trackingDashboardSpeakCustomerName) {
        audioText = I18n.t('BEE4427', {
          0: this.formatTextForAudio(explodedId),
          1: this.formatTextForAudio(this.SafeTextLimiter(customerName)),
        });
      }
    }

    if (trackingDashboardSoundOnBilling && event.newStatus === 9) {
      if (trackingDashboardSpeakOrderNumber && trackingDashboardSpeakCustomerName) {
        audioText = I18n.t('BEE4767', {
          0: this.formatTextForAudio(explodedId),
          1: this.formatTextForAudio(this.SafeTextLimiter(customerName)),
        });
      } else if (trackingDashboardSpeakOrderNumber && !trackingDashboardSpeakCustomerName) {
        audioText = I18n.t('BEE4764', {
          0: this.formatTextForAudio(explodedId),
        });
      } else if (!trackingDashboardSpeakOrderNumber && trackingDashboardSpeakCustomerName) {
        audioText = I18n.t('BEE4766', {
          0: this.formatTextForAudio(this.SafeTextLimiter(customerName)),
        });
      }
    }

    if (audioText) {
      setTimeout(() => this.speakText(audioText), 400);
    }
  };

  handleSoundAlerts = (event) => {
    const {
      trackingDashboardActivateSound,
      trackingDashboardSoundOnBilling,
    } = this.state;

    const oldStatus = Number(event.oldStatus);
    const newStatus = Number(event.newStatus);

    if (
      newStatus === 9
      && oldStatus !== 9
      && trackingDashboardSoundOnBilling
    ) {
      this.playBeep();
      this.playSoundAlertAudio(event);
    }

    if (
      newStatus === 14
      && oldStatus !== 14
      && trackingDashboardActivateSound
    ) {
      this.playBeep();
      this.playSoundAlertAudio(event);
    }
  };

  handleRealtimeStatusChange = (event) => {
    const {
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
    } = this.state;

    const { startDate, endDate } = this.props.dates;
    const selectedBranch = this.getSelectedBranchCode();

    if (!selectedBranch) return;
    if (String(event.branchCode).trim() !== selectedBranch) return;

    const trackedStatuses = trackingDashboardColumnSequence
      ? trackingDashboardColumnSequence.split('|').map((n) => parseInt(n, 10))
      : [4, 5, 9, 14];

    const orderTypes = trackingDashboardOrderTypes
      ? trackingDashboardOrderTypes.split('|')
      : [];

    const isRelevant = this.eventFilter(event, {
      trackedStatuses,
      orderTypes,
      startDate,
      endDate,
    });

    if (!isRelevant) return;

    this.handleSoundAlerts(event);
    this.getTracking();
  };

  eventFilter = (event, {
    trackedStatuses, orderTypes, startDate, endDate,
  }) => {
    const affectsColumn = trackedStatuses.includes(event.oldStatus)
    || trackedStatuses.includes(event.newStatus);

    if (!affectsColumn) return false;

    if (orderTypes.length > 0 && !orderTypes.includes(event.orderType)) {
      return false;
    }

    if (startDate && endDate && event.createdAt) {
      const created = new Date(event.createdAt);
      if (created < new Date(startDate).setHours(0, 0, 0, 0)) return false;
      if (created > new Date(endDate).setHours(23, 59, 59, 999)) return false;
    }

    return true;
  };

  getTracking = async () => {
    const { startDate, endDate } = this.props.dates;

    if (!this.props.selectedBranches || this.props.selectedBranches.length === 0) {
      addNotification(
        'warning',
        I18n.t('BEE4247' /* Informe o código da filial. */),
        I18n.t('BEE4247' /* Informe o código da filial. */),
        'top-right',
      );

      return;
    }

    const branchesToSearch = this.props.selectedBranches.map(({ value }) => value) || [];

    const {
      outboundOrders,
      trackingDashboardActivateSound,
      trackingDashboardSpeakCustomerName,
      trackingDashboardSpeakOrderNumber,
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
      trackingDashboardSoundOnBilling,
    } = await this.props.getOutboundOrderTrackingData({
      startDate,
      endDate,
      branchesToSearch,
    });

    this.setState({
      trackingDashboardActivateSound,
      trackingDashboardSpeakCustomerName,
      trackingDashboardSpeakOrderNumber,
      trackingDashboardColumnSequence,
      trackingDashboardOrderTypes,
      trackingDashboardSoundOnBilling,
      outboundOrderTrackingList: outboundOrders,
    }, () => {
      const branchCode = this.getSelectedBranchCode();
      if (this.state.socketConnected && branchCode) {
        joinBranchRoom(branchCode);
      }
    });
  };

  handleDateApplyEvent = async (value) => {
    const [startDate, endDate] = value;
    const dates = { startDate, endDate };
    await this.props.setDashboardOutboundOrdersDates(dates);
  };

  handleBranchesSelected = async (event) => {
    if (!event || event.length === 0) {
      await this.props.setSelectedUserBranches([]);
      return;
    }

    const lastSelected = event[event.length - 1];
    const selectedBranch = [{ value: lastSelected.value, label: lastSelected.label }];

    await this.props.setSelectedUserBranches(selectedBranch);
  };

  render() {
    const { outboundOrderTrackingList } = this.state;
    const startDate = (this.props.dates && this.props.dates.startDate) || startOfDay(new Date());
    const endDate = (this.props.dates && this.props.dates.endDate) || endOfDay(new Date());

    return (
      <div>
        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            {!!this.breadcrumb && this.breadcrumb.length && (
              <div className="d-flex align-items-center">
                <ol className="breadcrumb mb-2">
                  {this.breadcrumb.map((it, index) => (
                    <li
                      key={`${it.value}${index}`}
                      className={`breadcrumb-item${it.active ? ' active' : ''}`}
                    >
                      {it.iconClassName ? (
                        <>
                          <i className="fa fa-chart-line m-t-10 m-r-5" />
                          {' '}
                          {it.value}
                        </>
                      ) : (
                        it.value
                      )}
                    </li>
                  ))}
                </ol>
              </div>
            )}

            <div className="d-flex align-items-center">
              <h1 className="page-header mb-0">
                {I18n.t('BEE4353' /* Acompanhamento de Documentos de Saída */)}
              </h1>
              <WikiHelp wikiPath={ROUTES.OUTBOUND_ORDER_TRACKING_HELP} />
            </div>

            <div className="d-sm-flex">
              <div className="d-flex mt-2">
                <DateRangePicker
                  onChange={this.handleDateApplyEvent}
                  defaultValue={[new Date(startDate), new Date(endDate)]}
                />
              </div>

              <div className="d-flex mt-2">
                <FilterSelectionList
                  value={this.props.selectedBranches}
                  onChangeValue={this.handleBranchesSelected}
                  placeholderValue={I18n.t('BEE4371' /* Selecione uma filial. */)}
                  optionsValue={this.state.listBranches}
                  onClickValue={this.getTracking}
                />
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DigitalClock showAutoRefresh={false} />
          </div>
        </div>

        <div>
          {this.state.trackingDashboardColumnSequence && (
            <TrackingOrderCards
              data={[
                outboundOrderTrackingList,
                this.state.trackingDashboardColumnSequence,
              ]}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userBranches: state.outboundOrders.userBranches,
  dates: state.outboundOrders.dates,
  selectedBranches: state.outboundOrders.selectedBranches,
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardOutboundOrdersDates: (dates) => dispatch(setDashboardOutboundOrdersDates(dates)),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getOutboundOrderTrackingData: (parameters) => dispatch(getOutboundOrderTrackingData(parameters)),
  setSelectedUserBranches: (selectedBranches) => dispatch(setSelectedUserBranches(selectedBranches)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundOrderTracking));
